export const isDoctor = (role) => {
    return role==='Doctor';    
}

export const canEditDoctor = (cita, auth) => {
    let validation = false;

    if (auth.data.company.id === 1) {
        return true;
    }

    if (cita?.scheduleDTO.doctor.email === auth.data.username && auth.data.company.id === 2) {
        console.log("entre");
        const [datePart, timePart] = cita.createdAt.split(" ");
        const [day, month, year] = datePart.split("/");
        const [hours, minutes, seconds] = timePart.split(":");
        const createdDate = new Date(year, month - 1, day, hours, minutes, seconds);
        const now = new Date();

        // Diferencia en milisegundos
        const diffMs = now - createdDate;

        // 24 horas en milisegundos
        const hours24 = 24 * 60 * 60 * 1000;

        if (diffMs <= hours24) {
            validation = true;
        }
    }

    return validation;
}